export const URLAPISUBIDA = 'https://quesuditas.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://quesuditas.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://quesuditas.com/notis/'

export const URLAPISUBIDAPDF = 'https://quesuditas.com/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://quesuditas.com/notis/'